import { render, staticRenderFns } from "./undirect-send.vue?vue&type=template&id=185265f8&"
import script from "./undirect-send.vue?vue&type=script&lang=js&"
export * from "./undirect-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports